import { UpdateSecondHandSupplyService } from './../../services/update-second-hand-supply.service';
import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SecondHandSupply } from '../../models/second-hand-supply';

@Component({
  selector: 'app-active',
  templateUrl: './active.component.html',
  styleUrls: ['./active.component.scss']
})
export class ActiveComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<ActiveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSupply,
    private updateSecondHandSupplyService: UpdateSecondHandSupplyService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  async updateSecondHandSupply(){
    try{
      await this.updateSecondHandSupplyService.updateSecondHandSupplyByPk(this.data.id, {product_status: 'ACTIVE'})
      this.toast.openSnackBar("This product is activated successfully");
      this.closeDialog('yes');
    } catch(error){
      this.toast.openSnackBar("Unable to activate the product");
    }
  }
}



